export interface Style {
  title: string;
  textures: string;
  reflection: string;
  reflectionLevel: number;
  colorText: string;
  ground: string;
  skyboxExposure: number,
  skyboxRotation: number,
  menuRotation: number,
  groundRotation: number,
  playerRotation: number,
}

export const styles: Style[] = [
  {
    title: "Rathaus Square",
    textures: "plaza",
    reflection: "rathaus_1k",
    reflectionLevel: .5,
    colorText: "#dac89b",
    ground: "uihnfbhv_2K",
    skyboxExposure: .2,
    skyboxRotation: -Math.PI / 3,
    menuRotation: -Math.PI / 3,
    groundRotation: -Math.PI / 3,
    playerRotation: -Math.PI / 3,
  },
  {
    title: "St. Peters Night",
    textures: "petersnight",
    reflection: "petersnight",
    reflectionLevel: .8,
    colorText: "#dac89b",
    ground: "wgildgjv_2K",
    skyboxExposure: .7,
    skyboxRotation: -Math.PI / 3,
    menuRotation: Math.PI / 2,
    groundRotation: Math.PI / 2,
    playerRotation: Math.PI / 2,
  },
  // {
  //   title: "Viale Giuseppe Garibaldi",
  //   textures: "garibaldi",
  //   reflection: "garibaldi",
  //   reflectionLevel: .3,
  //   colorText: "#dac89b",
  //   ground: "uihnfbhv_2K",
  //   skyboxExposure: .4,
  //   skyboxRotation: Math.PI / 3,
  //   menuRotation: Math.PI,
  //   groundRotation: Math.PI,
  //   playerRotation: Math.PI,
  // },
  // {
  //   title: "Satara Night",
  //   textures: "satara",
  //   reflection: "satara",
  //   reflectionLevel: .5,
  //   colorText: "#dac89b",
  //   ground: "uihnfbhv_2K",
  //   skyboxExposure: .2,
  //   skyboxRotation: -Math.PI / 3,
  //   menuRotation:  Math.PI / 3,
  //   groundRotation: Math.PI / 3,
  //   playerRotation: Math.PI / 3,
  // },
  {
    title: "Blaubeuren Church Square",
    textures: "blaubeuren",
    reflection: "blaubeuren",
    reflectionLevel: .5,
    colorText: "#dac89b",
    ground: "uihnfbhv_2K",
    skyboxExposure: .2,
    skyboxRotation: Math.PI / 3,
    menuRotation: -Math.PI / 3,
    groundRotation: -Math.PI / 3,
    playerRotation: -Math.PI / 3,
  },
  {
    title: "Shanghai Bund",
    textures: "shanghai",
    reflection: "shanghai",
    reflectionLevel: .3,
    colorText: "#dac89b",
    ground: "wgildgjv_2K",
    skyboxExposure: .2,
    skyboxRotation: Math.PI / 1.9,
    menuRotation: -Math.PI / 1.9,
    groundRotation: -Math.PI / 1.9,
    playerRotation: -Math.PI / 1.9,
  },
]

const idx = Math.floor(Math.random() * styles.length);
export const getStyle = () => {
  return styles[idx];
}
